export default "__VITE_ASSET__uQ_BC5lT__"